"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossdockCostClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const Logger_1 = require("@deliverr/commons-logs/lib/Logger");
class CrossdockCostClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {}, serviceUrl = process.env.BILLING_SERVICE_URL, authUser = process.env.BILLING_BASIC_AUTH_USER, authPassword = process.env.BILLING_BASIC_AUTH_PASSWORD) {
        super(Object.assign(Object.assign({}, config), { baseURL: `${config.baseURL || serviceUrl}`, basicAuthPassword: authPassword, basicAuthUser: authUser }));
        this.serviceUrl = serviceUrl;
        this.authUser = authUser;
        this.authPassword = authPassword;
        if (!this.serviceUrl) {
            Logger_1.log.warn("BILLING_SERVICE_URL environment variable is not set");
        }
        if (!this.authUser || !this.authPassword) {
            Logger_1.log.warn("BILLING_BASIC_AUTH_USER and BILLING_BASIC_AUTH_PASSWORD environment variables not set");
        }
    }
    async createCrossdockCost(crossdockCostData) {
        return this.post(`/crossdock-fee/v1/create`, crossdockCostData);
    }
    async getCrossdockCost(shippingPlanId) {
        return this.get(`/crossdock-fee/v1/${shippingPlanId}`);
    }
}
exports.CrossdockCostClient = CrossdockCostClient;
//# sourceMappingURL=CrossdockCostClient.js.map